import React from 'react';
import {Banner, List} from '@shopify/polaris';
import CsI18n from "../../components/csI18n";
import Context from "../../context";
import ApplicationApiCall from "../../functions/application-api-call";
import CsAppBridge from "../../CsAppBridge";

export const ErrorType = {
  NETWORK: 1,
  INVALID_PARAM: 2,
  NORMAL: 3,
  TIMEOUT: 4,
  CUSTOM: 5,
}

export default class CsErrorMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reporting: false,
      reported: false
    };
    this.shopify = Context.getShared();
  }

  processSupport = () => {
    this.setState({reporting: true});
    let {errorMessage} = this.props;
    let configuration = this.shopify.getConfigurationSelected();
    let params = {configuration, errorMessage};
    ApplicationApiCall.get('/application/support/error_send', params, (json) => {
      console.log(json);
      this.setState({reporting: false, reported: true}, () => {
        CsAppBridge.toastSuccess(CsI18n.t("The problem has been reported. We will contact you ASAP."));
      });
    }, (err) => {
      console.log(err);
      this.setState({reporting: false, reported: true}, () => {
        CsAppBridge.toastSuccess(CsI18n.t("The problem has been reported. We will contact you ASAP."));
      });
    });
  }

  parseErrorMessage = message => {
    const startIndex = message.indexOf("please contact our support and mention incident id");
    return startIndex !== -1
      ? message.substring(startIndex).replace(/^please/, "Please")
      : message;
  }

  render() {
    let {errorType, errorTitle, errorMessage} = this.props;

    switch (errorType) {
      case ErrorType.NETWORK:
        errorTitle = CsI18n.t("Unknown error");
        break;
      case ErrorType.INVALID_PARAM:
        errorTitle = CsI18n.t("Error");
        break;
      case ErrorType.TIMEOUT:
        errorTitle = CsI18n.t("Timed Out");
        break;
    }

    if (errorMessage && Array.isArray(errorMessage) && errorMessage.length > 0) {
      return (
        <Banner
          title={errorTitle}
          status="critical"
          action={{
            content: CsI18n.t("Contact support"),
            onAction: this.processSupport,
            loading: this.state.reporting && !this.state.reported,
            disabled: this.state.reported
          }}
        >
          <List type="bullet">
            {errorMessage.map((item, index) => {
              return <List.Item key={`error-line-${index}`}>
                {this.parseErrorMessage(item)}
              </List.Item>
            })}
          </List>
        </Banner>
      )
    } else if (errorMessage) {
      return (
        <Banner
          title={errorTitle}
          status="critical"
          action={{
            content: CsI18n.t("Contact support"),
            onAction: this.processSupport,
            loading: this.state.reporting && !this.state.reported,
            disabled: this.state.reported
          }}
        >
          {this.parseErrorMessage(errorMessage)}
        </Banner>
      )
    } else if (errorTitle) {
      return <Banner
        title={errorTitle}
        status="critical"
        action={{
          content: CsI18n.t("Contact support"),
          onAction: this.processSupport,
          loading: this.state.reporting && !this.state.reported,
          disabled: this.state.reported
        }}
      />
    } else {
      return null;
    }
  }
}

CsErrorMessage.defaultProps = {
  errorType: ErrorType.NORMAL,
  errorMessage: "",
}
